import * as Api from "./api";

const CHECK_USERNAME_API_URL = "/login/usernameexists";
const VERIFY_LOGIN_API_URL = "/login/VerifyLogin";
const PASSWORDLESS_LOGIN_API_URL = "/login/RequestPasswordlessLogin";
const RESET_PASSWORD_API_URL = "/password/VerifyForgotPassword";
const ALREADY_AUTHENTICATED_URL = "/login/isauthenticated";

export function checkIfEmailExists(data) {
	return Api.getFromApi(
		`${CHECK_USERNAME_API_URL}?username=${encodeURIComponent(
			(data.email || "").trim(),
		)}&returnUrl=${encodeURIComponent(data.returnUrl)}`,
	);
}

export function verifyLogin(data) {
	return Api.postToApi(VERIFY_LOGIN_API_URL, data);
}

export function passwordLessLogin(data) {
	return Api.postToApi(PASSWORDLESS_LOGIN_API_URL, data);
}

export function resetPassword(data) {
	return Api.postToApi(RESET_PASSWORD_API_URL, data);
}

export function isAlreadyAuthenticated(data) {
	return Api.getFromApi(
		`${ALREADY_AUTHENTICATED_URL}?returnUrl=${encodeURIComponent(
			data.returnUrl,
		)}`,
	);
}
